<div class="page-title-section row m-0 pt-5 pb-4 flex-column">
  <div class="main-title main-theme-color d-flex justify-content-center text-center text-uppercase">
    {{ "orderSummary" | translate }}
  </div>
  <div
    class="sub-title secondary-theme-color position-relative  justify-content-center text-center text-uppercase flex-wrap order-summary-sub-title">
    {{ "checkYourActivityBeforeBooking" | translate }}
    <div *ngIf="!isEdit" class="d-flex clear-cart-decoration justify-content-center">
      <a class="text-uppercase" (click)="clearCart()">{{
        "clearCart" | translate
        }}</a>
    </div>
  </div>
</div>
<div class="cart__warningmessage text-center pt-3" *ngIf="showCartLockWarning">
  {{ "cartLockWarningMessage" | translate }}
</div>
<div class="cart__warningmessage text-center pt-3" *ngIf="infoMessage">
  {{ infoMessage }}
</div>
<div class="d-flex flex-wrap justify-content-center">
  <div class="col-md-12 m-top"></div>

  <div class="col-xl-4 col-lg-6 col-12 mt-3 mt-xl-0" *ngIf="overallBookings?.length > 0" [hidden]="activityService?.DisableCustomTermsAndConditions && isValidateTerms">
    <!-- Add multi to show multiple expansion parallely or only one expansion to be open at a time -->
    <mat-accordion multi="true" class="activity-accordian-accordian">
      <!-- Remove disabled when having more than 1 slot bookings -->
      <mat-expansion-panel hideToggle [expanded]="actIndex == 0" class="mb-3 activity-accordian-panel"
        *ngFor="let slot of overallBookings; let actIndex = index" [disabled]="
          slot.bookingTypeVariants?.length === 0 &&
          slot.coverTypeVariants?.length === 0 &&
          !slot.TotalAmount &&
          !slot.TotalAddonAmount &&
          !slot.RateplanAmountinfo
        ">
        <mat-expansion-panel-header class="activity-panel-header">
          <div class="flex-column w-100">
            <div class="w-100 order-summary-short-detail-section p-3 mx-2 d-flex flex-row justify-content-between"
              [ngStyle]="{
              'background-color': !slot.isAvailable ? 'rgba(255,0,0,0.1)' : ''
            }" [class.auth-card-booking]="
              slot.WidgetPrePaymentMode === AuthOnlyPaymentMode
            ">
              <div
                class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center text-center">
                <mat-icon>card_travel</mat-icon>
                <div class="px-2 order-details-activity-name text-wrap text-center">
                  {{ slot.ActivityName }}
                </div>
              </div>
              <div class="order-summary-spacer mx-2"></div>
              <div
                class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
                <mat-icon>person</mat-icon>
                <div class="px-2 text-center">{{ slot.Size }}</div>
              </div>
              <div class="order-summary-spacer mx-2"></div>
              <div
                class="activity-selected-date activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
                <mat-icon>calendar_today</mat-icon>
                <div class="px-2 text-center">
                  <ng-container>{{
                    (slot?.TimeRange?.Start
                    ? slot?.TimeRange?.Start
                    : slot.FormattedLocalTime
                    )
                    | date
                    : "dd MMM yyyy"
                    }}</ng-container>
                </div>
              </div>
              <div class="order-summary-spacer mx-2"></div>
              <div
                class="activity-selected-time activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
                <mat-icon>access_time</mat-icon>
                <div class="px-2 d-flex align-items-center justify-content-center">
                  <span class="text-center">
                    <ng-container>{{
                      (slot?.TimeRange?.Start
                      ? slot?.TimeRange?.Start
                      : slot.FormattedLocalTime
                      ) | date : "hh:mm a"
                      }}</ng-container>
                  </span>
                </div>
              </div>
              <div *ngIf="!isEdit"
                class="activity-location activity-description-bold d-flex flex-end justify-content-center align-items-center"
                (click)="deleteCartItem(actIndex, $event)">
                <mat-icon matTooltip="{{ 'Delete' | translate }}">
                  <mat-icon>delete</mat-icon>
                </mat-icon>
              </div>
              <div *ngIf="slot.WidgetPrePaymentMode === AuthOnlyPaymentMode" class="auth-card-icon">
                <img src="assets/images/auth_card.svg" alt="agilysys-logo" />
              </div>
            </div>
            <div class="no-showfee-cell" *ngIf="slot.NoShowFeeAmount">
              <span>
                {{'noShowFee' | translate}}
                <span class="icon-Info" [matTooltip]="'RestaurantCreditCardAssurance' | translate"></span>
              </span>
              <span>{{ operationCurrency
                  }} {{slot.NoShowFeeAmount | number : "1.2-2"}}</span>
            </div>
          </div>
        </mat-expansion-panel-header>

        <div class="price-splitup-section" [hidden]="slot?.Total == 0">
          <div class="p-0 col-12 price-splitup-table d-flex flex-column">
            <div class="py-1 price-table-header d-flex flex-row">
              <div class="p-0 col-lg-6 col-5">
                <div class="activity-description-bolder">
                  {{ _MESSAGES.Labels.description | translate }}
                </div>
              </div>
              <div class="p-0 col-lg-2 col-2 d-flex justify-content-center">
                <div class="activity-description-bolder text-right">
                  {{ _MESSAGES.Labels.quantity | translate }}
                </div>
              </div>
              <div class="p-0 col-lg-2 col-2 d-flex justify-content-end">
                <div class="activity-description-bolder text-right">
                  {{ _MESSAGES.Labels.grossPrice | translate }}
                </div>
              </div>
              <div class="p-0 col-lg-2 col-3 d-flex justify-content-end">
                <div class="activity-description-bolder text-right">
                  {{ _MESSAGES.Labels.totalPrice | translate }}
                </div>
              </div>
            </div>
            <div class="py-1 price-table-data-cell d-flex flex-row flex-wrap">

              <div class="p-0 col-lg-10 col-10">
                <div class="activity-description-bold text-wrap cursor" (click)="showDetailedView = !showDetailedView">
                   {{ slot.ActivityName }} 
                  <span class="down-icon mb-1 ms-2 "
                  
                  [ngClass]="{'expandedView': showDetailedView}"></span>
                </div>
              </div>
                <div class="p-0 col-lg-2 col-2 d-flex justify-content-end">
                  <div class="activity-description-bold text-truncate">
                    {{ operationCurrency
                    }}{{
                    (slot.SubTotal ? slot.SubTotal : 0)
                    | currencyDecimalFormatter
                    }}
                  </div>
                  <!-- <mat-icon class="ps-3 ordered-activity-delete">delete</mat-icon> -->
                </div>
              
            </div>
            <div *ngIf="showDetailedView">
            <div class="py-1 price-table-data-cell d-flex flex-row flex-wrap" 
              *ngFor="let lineItem of slot.Items; let i = index">
              <div class="p-0 col-lg-6 col-5">
                <div class="activity-description-bold text-wrap ps-5" >
                  {{ lineItem.Name }}
                  <!-- <span class="down-icon mb-1 ms-2 " *ngIf="lineItem.VAT > 0"
                    
                    [ngClass]="{'expandedView': lineItem['TaxExpandedView']}"></span> -->
                </div>
              </div>

              <div class="p-0 col-lg-2 col-2 d-flex justify-content-center">
                <div class="activity-description-bold">
                  {{ lineItem | groupItemByType: slot : 'Count' }}
                </div>
              </div>
              <div class="p-0 col-lg-2 col-2 d-flex justify-content-end">
                <div class="activity-description-bold text-truncate">
                  {{ operationCurrency
                  }}
                  {{
                  (lineItem.PayableUnitPrice ? ( lineItem.PayableUnitPrice ) : 0) | currencyDecimalFormatter
                  }}
                </div>
              </div>
              <div class="p-0 col-lg-2 col-3 d-flex justify-content-end">
                <div class="activity-description-bold text-truncate">
                  {{ operationCurrency
                  }}{{
                  (lineItem.SubTotal ? ( lineItem | groupItemByType: slot : 'SubTotal' ) : 0)
                  | currencyDecimalFormatter
                  }}
                </div>
                <!-- <mat-icon class="ps-3 ordered-activity-delete">delete</mat-icon> -->
              </div>

            </div>

            <span class="w-100 ps-5"
              *ngIf="slot && (slot.VAT > 0 || slot.Tax > 0) && ((showDetailedView && taxTypeForBooking) )">
              <ng-container class="py-1 price-table-data-cell d-flex flex-row"
                *ngTemplateOutlet="vatInfo; context: { $implicit: slot }">
              </ng-container>
            </span>
            <!-- Total tax and Service Charge Amount -->
            <span *ngIf="slot && slot.ServiceCharge > 0 ">
              <ng-container class="py-1 price-table-data-cell d-flex flex-row" *ngTemplateOutlet="
                  serviceChargeInfo;
                  context: { $implicit: slot }
                ">
              </ng-container>
            </span>
            <span class="w-100 " *ngIf="slot && (slot.VAT > 0 || slot.Tax > 0) && !taxTypeForBooking">
              <ng-container class="py-1 price-table-data-cell d-flex flex-row"
                *ngTemplateOutlet="vatInfo; context: { $implicit: slot }">
              </ng-container>
            </span>
            <div class="py-1 price-table-data-cell d-flex flex-row"
              *ngIf="slot?.RatePlanTotal?.MinRateAdjustmentAmount > 0">
              <div class="p-0 col-lg-6 col-5">
                <div class="activity-description-bold text-wrap">
                  {{ _MESSAGES.Labels.minRateAdjustment | translate }}
                </div>
              </div>
              <div class="p-0 col-lg-2 col-2 d-flex justify-content-center">
                <div class="activity-description-bold"></div>
              </div>
              <div class="p-0 col-lg-4 col-5 d-flex justify-content-end float-right">
                <div class="activity-description-bold text-truncate">
                  {{ operationCurrency
                  }}{{
                  (slot?.RatePlanTotal?.MinRateAdjustmentAmount
                  ? slot?.RatePlanTotal?.MinRateAdjustmentAmount
                  : 0
                  ) | currencyDecimalFormatter
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <ng-template #vatInfo let-paymentData>
      <div class="d-flex flex-row justify-content-between cursor">
        <div class="p-0 col-9">
          <div class="activity-description-bold" (click)="
              paymentData['TaxExpandedView'] = !paymentData['TaxExpandedView']
            ">
            <span class="pe-2">{{
              taxTypeForBooking ? "VAT" : ("Tax" | translate)
              }}</span>
            <ng-container>
              <span class="down-icon mb-1 ms-2" [ngClass]="{ expandedView: paymentData['TaxExpandedView'] }"></span>
            </ng-container>
          </div>
        </div>
        <div class="p-0 col-3 d-flex justify-content-end">
          <div class="activity-description-bold">
            {{ operationCurrency }}
            {{
            taxTypeForBooking
            ? paymentData?.VAT
            : (paymentData?.Tax | currencyDecimalFormatter)
            }}
          </div>
        </div>
      </div>
      <ng-container *ngIf="paymentData?.TaxExpandedView && paymentData?.Taxes?.length">
        <div class="d-flex flex-row justify-content-between p-0 ps-5 tax-list col-lg-12 col-md-12"
          *ngFor="let taxItem of paymentData?.Taxes">
          <div class="p-0 col-9">
            <div class="activity-description-bold">
              <span *ngIf="taxItem.IsPercentage">{{ taxItem.ChargeName }} @ {{ taxItem.ChargeValue }}%
              </span>
              <span *ngIf="!taxItem.IsPercentage">{{ taxItem.ChargeName }}
              </span>
            </div>
          </div>
          <div class="p-0 col-3 d-flex justify-content-end">
            <div class="activity-description-bold">
              {{ operationCurrency }}
              {{ taxItem.Amount | currencyDecimalFormatter }}
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #serviceChargeInfo let-paymentData>
      <div (click)="
          paymentData['serviceChargeExpandedView'] =
            !paymentData['serviceChargeExpandedView']
        " class="d-flex flex-row justify-content-between cursor">
        <div class="p-0 col-9">
          <div class="activity-description-bold">
            <span class="pe-2">{{"serviceCharges" | translate}}</span><span class="down-icon mb-1 ms-2" [ngClass]="{
                expandedView: paymentData['serviceChargeExpandedView']
              }"></span>
          </div>
        </div>
        <div class="p-0 col-3 d-flex justify-content-end">
          <div class="activity-description-bold">
            {{ operationCurrency }}
            {{ paymentData.ServiceCharge | currencyDecimalFormatter }}
          </div>
        </div>
      </div>
      <ng-container *ngIf="paymentData['serviceChargeExpandedView']">
        <div *ngFor="let serviceItem of paymentData?.ServiceCharges"
          class="d-flex flex-row flex-wrap justify-content-between ps-5 tax-list">
          <div class="p-0 col-9">
            <div class="activity-description-bold">
              <span *ngIf="serviceItem.IsPercentage">{{ serviceItem.ChargeName }} @ {{ serviceItem.ChargeValue }}%
              </span>
              <span *ngIf="!serviceItem.IsPercentage">{{ serviceItem.ChargeName }}
              </span>
            </div>
          </div>
          <div class="p-0 col-3 d-flex justify-content-end">
            <div class="activity-description-bold">
              {{ operationCurrency }}
              {{ serviceItem.Amount | currencyDecimalFormatter }}
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between p-0 ps-5 tax-list col-lg-12 col-md-12"
            *ngFor="let taxItem of serviceItem.Taxes">
            <div class="p-0 col-9">
              <div class="activity-description-bold">
                <span *ngIf="taxItem.IsPercentage">{{ taxItem.ChargeName }} @ {{ taxItem.ChargeValue }}%
                </span>
                <span *ngIf="!taxItem.IsPercentage">{{ taxItem.ChargeName }}
                </span>
              </div>
            </div>
            <div class="p-0 col-3 d-flex justify-content-end">
              <div class="activity-description-bold">
                {{ operationCurrency }}
                {{ taxItem.Amount | currencyDecimalFormatter }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>

    <div *ngIf="false" class="p-5 order-summary-empty-data activity-description-bold text-center">
      {{ "noGuestsSelected" | translate }}
    </div>
    <div class="pe-4 ps-4">
      <div class="my-4 py-3 order-summary-total-price"></div>
      <ng-container *ngIf="paymentData">
        <div *ngIf="paymentData.SubTotal" class="d-flex flex-row justify-content-between">
          <div class="p-0 col-9">
            <div class="activity-description-bold">
              {{ "SubTotal" | translate }}
            </div>
          </div>
          <div class="p-0 col-3 d-flex justify-content-end">
            <div class="activity-description-bold">
              {{ operationCurrency }}
              {{ paymentData.SubTotal | currencyDecimalFormatter }}
            </div>
          </div>
        </div>
      </ng-container>
      <!-- Total tax and Service Charge Amount -->
      <span *ngIf="
          paymentData && paymentData?.ServiceCharge > 0 && !taxTypeForBooking
        ">
        <ng-container class="py-1 price-table-data-cell d-flex flex-row" *ngTemplateOutlet="
            serviceChargeInfo;
            context: { $implicit: paymentData }
          ">
        </ng-container>
      </span>

      <span *ngIf="paymentData && paymentData?.Tax > 0 && !taxTypeForBooking">
        <ng-container class="py-1 price-table-data-cell d-flex flex-row"
          *ngTemplateOutlet="vatInfo; context: { $implicit: paymentData }">
        </ng-container>
      </span>

      <ng-container *ngIf="paymentData?.TaxOnServiceChargeAmount > 0">
        <div class="d-flex flex-row justify-content-between">
          <div class="p-0 col-9">
            <div class="activity-description-bold">
              {{ "taxOnserviceCharge" | translate }}
            </div>
          </div>
          <div class="p-0 col-3 d-flex justify-content-end">
            <div class="activity-description-bold">
              {{ operationCurrency }}
              {{paymentData.TaxOnServiceChargeAmount | currencyDecimalFormatter}}
            </div>
          </div>
        </div>
      </ng-container>

      <!-- <ng-container *ngIf="paymentData && paymentData?.SubTotal > 0">
      <div (click)="showTaxDetails = !showTaxDetails" class="d-flex flex-row justify-content-between ps-3 pe-3 cursor">
        <div class="p-0 col-9">
          <div class="activity-description-bold">{{ 'Tax' | translate}}
          </div>
        </div>
        <div class="p-0 col-3 d-flex justify-content-end">
          <div class="activity-description-bold">{{operationCurrency}} {{ paymentData.Tax | currencyDecimalFormatter}}
          </div>
        </div>
      </div>
      <ng-container *ngIf="showTaxDetails">
        <div class="d-flex flex-row justify-content-between ps-3 pe-3 tax-list"
          *ngFor="let taxItem of paymentData.Taxes | filterTaxType : taxType.Tax">
          <div class="p-0 col-9">
            <div class="activity-description-bold"> <span *ngIf="taxItem.IsPercentage">{{taxItem.ChargeName}} @
                {{taxItem.ChargeValue}}% </span>
              <span *ngIf="!taxItem.IsPercentage">{{taxItem.ChargeName}} </span>
            </div>
          </div>
          <div class="p-0 col-3 d-flex justify-content-end">
            <div class="activity-description-bold">{{operationCurrency}} {{taxItem.Amount | currencyDecimalFormatter}}
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container> -->

      <!-- <ng-container *ngIf="taxTypeForBooking && paymentData?.VAT > 0">
        <div class="d-flex flex-row justify-content-between ps-3  ">
          <div class="p-0 col-9">
            <div class="activity-description-bold">{{'VAT' | translate}}
            </div>
          </div>
          <div class="p-0 col-3 d-flex justify-content-end">
            <div class="activity-description-bold">{{operationCurrency}} {{ paymentData?.VAT |
              currencyDecimalFormatter}}
            </div>
          </div>
        </div>
      </ng-container> -->

      <ng-container *ngIf="taxTypeForBooking && paymentData?.ServiceCharge > 0">
        <div class="d-flex flex-row justify-content-between">
          <div class="p-0 col-9">
            <div class="activity-description-bold">
              {{ "serviceCharges" | translate }}
            </div>
          </div>
          <div class="p-0 col-3 d-flex justify-content-end">
            <div class="activity-description-bold">
              {{ operationCurrency }}
              {{ paymentData?.ServiceCharge | currencyDecimalFormatter }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div *ngIf="TotalAmount" class="py-4 m-2 px-3 order-summary-grand-total d-flex flex-row justify-content-between"
      [class.highlightSection]="
        showCardOnFileInformation && TotalAmount != PayableAmount
      ">
      <div class="p-0 col-6">
        <div class="d-flex align-items-center activity-title text-uppercase">
          {{ "grandTotal" | translate
          }}<mat-icon *ngIf="false" matTooltip="{{ 'inclusiveOfAllTaxes' | translate }}" matTooltipPosition="above"
            class="ms-3 d-flex align-items-center list-info-icon cursor">
            info
          </mat-icon>
        </div>
      </div>
      <div class="p-0 col-6 d-flex justify-content-end">
        <div class="activity-title">
          {{ operationCurrency }}
          {{ (TotalAmount ? TotalAmount.valueOf() : 0) | currencyDecimalFormatter }}
        </div>
      </div>
    </div>
    <div *ngIf="showCardOnFileInformation && TotalAmount != PayableAmount"
      class="py-4 m-2 px-3 order-summary-grand-total d-flex flex-row justify-content-between">
      <div class="p-0 col-6">
        <div class="d-flex align-items-center activity-title text-uppercase">
          {{ "AmountPayable" | translate
          }}<mat-icon *ngIf="false" matTooltip="{{ 'inclusiveOfAllTaxes' | translate }}" matTooltipPosition="above"
            class="ms-3 d-flex align-items-center list-info-icon cursor">
            info
          </mat-icon>
        </div>
      </div>
      <div class="p-0 col-6 d-flex justify-content-end">
        <div class="activity-title">
          {{ operationCurrency }}
          {{ PayableAmount | currencyDecimalFormatter }}
        </div>
      </div>
    </div>
    <div *ngIf="isEdit && balanceAmount > 0" class="px-3 m-2 d-flex flex-row justify-content-between">
      <div class="p-0 col-9">
        <div class="activity-description-bold">
          {{ "amountPaid" | translate }}
        </div>
      </div>
      <div class="p-0 col-3 d-flex justify-content-end">
        <div class="activity-description-bold">
          {{ operationCurrency
          }}{{
          (TotalAmount
          ? TotalAmount.valueOf() -
          (!refundAmount ? balanceAmount.valueOf() : 0)
          : 0
          ) | currencyDecimalFormatter
          }}
        </div>
      </div>
    </div>
    <div *ngIf="isEdit && balanceAmount > 0" class="px-3 m-2 d-flex flex-row justify-content-between">
      <div class="p-0 col-9">
        <div class="activity-description-bolder">
          {{
          (!refundAmount ? "balancePendingAmount" : "refundAmount")
          | translate
          }}
        </div>
      </div>
      <div class="p-0 col-3 d-flex justify-content-end">
        <div class="activity-description-bolder">
          {{ operationCurrency
          }}{{ balanceAmount.valueOf() | currencyDecimalFormatter }}
        </div>
      </div>
    </div>
    <div class="auth-card-info" *ngIf="showCardOnFileInformation">
      <img class="auth-card-info__logo" src="assets/images/auth_card.svg" alt="agilysys-logo" />
      <div class="auth-card-info__message">
        <div *ngIf="
            !activityService.widgetSettings?.AuthorizeAndPayLaterNote?.length
          ">
          {{ "authCardInfoMessageInfo" | translate }}
          <b>
            {{ "authCardInfoMessageOption" | translate }}
          </b>
          {{ "authCardInfoMessageValue" | translate }}
        </div>
        <div *ngIf="
            activityService.widgetSettings?.AuthorizeAndPayLaterNote?.length
          ">
          {{ activityService.widgetSettings?.AuthorizeAndPayLaterNote }}
        </div>
      </div>
    </div>

    <div class="px-3 m-2 d-flex flex-column justify-content-between">
      <div class="mt-2 d-flex flex-row justify-content-between save-to-contact" *ngIf="showIframe">
        <mat-checkbox class="chip-control__checkbox" [(ngModel)]="saveCardToContact">{{'saveCardToPayer' |
          translate}}</mat-checkbox>
      </div>
      <form #guestDetailsForm="ngForm" novalidate id="guestDetailsForm">
        <ng-container *ngTemplateOutlet="termsConditions"> </ng-container>
      </form>
    </div>
    <div *ngIf="
        !(
          urlSafe &&
          (waiverForm ||
            activityService?.reservationAttemptInfo?.CreditCardIframeUrl ||
            activityService?.reservationAttemptInfo?.CreditCardIFrameURL ||
            financialData?.RedirectUrl)
        ) || enableSubmit
      " class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="d-flex flex-row justify-content-center">
        <button mat-button type="button" class="m-5 activity-buttons activity-confirm-buttons text-center"
          [disabled]="disableSubmitButton" (click)="clickToPayment()">
          <!-- {{'CLICK TO PAY' | translate}} -->
          {{ "submit" | translate }}
        </button>
      </div>
    </div>
    <div *ngIf="(
      urlSafe &&
      (waiverForm ||
        activityService?.reservationAttemptInfo?.CreditCardIframeUrl ||
        activityService?.reservationAttemptInfo?.CreditCardIFrameURL ||
        financialData?.RedirectUrl)
    ) 
    && activityService?.DisableCustomTermsAndConditions" class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="d-flex flex-row justify-content-center">
        <button mat-button type="button" class="m-5 activity-buttons activity-confirm-buttons text-center" (click)="validateForm()">
          {{ "next" | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- large screen terms and condition view removed  -->
  <!-- <ng-container>
    <div class="d-block d-lg-none">
      <ng-container *ngTemplateOutlet="termsConditions">
      </ng-container>
    </div>
  </ng-container> -->
  <div *ngIf="
      urlSafe &&
      (waiverForm ||
        activityService?.reservationAttemptInfo?.CreditCardIframeUrl ||
        financialData?.RedirectUrl ||
        activityService?.reservationAttemptInfo?.CreditCardIFrameURL)
    " class="col-xl-4 col-lg-5 col-12 mt-3 mt-xl-0 justify-content-center"[ngClass]="{'d-flex': isValidateTerms}" [hidden]="!isValidateTerms">
    <!-- <img style="width: 100%;" src="assets/images/payment-iframe.jpg" /> -->

    <!-- *ngIf="urlSafe && !activityService.editFromCart && (!activityService.restaurantWidgetSettings$.value.IsCartEnabled || activityService.operation != operationType.create || waiverForm)" -->
    <div class="guest-data__iframe-view position-relative">
      <iframe width="100%" height="500px" frameBorder="0" [src]="urlSafe"></iframe>
      <div *ngIf="checkBoxErrorMessages || showCartLockWarning"
        class="px-5 position-absolute activity-description-bold payment-protection d-flex flex-column justify-content-center">
        <div class="p-3 d-flex justify-content-center payment-overlay-text align-items-center text-center">
          {{ "enterNecessaryDetailsForPayment" | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #termsConditions>
  <div class=" d-flex flex-column">
    <div class="py-2 d-flex flex-nowrap" *ngFor="let eachTerms of customTerms; let i = index">
      <div>
        <mat-checkbox class="chip-control__checkbox" [(ngModel)]="eachTerms.labelValue" #eachTerms="ngModel"
          [disabled]="eachTerms.disabled" [checked]="eachTerms.labelValue" name="{{ eachTerms.name }}"
          (ngModelChange)="checkCustomTermsAndMessageOptionValidation()"></mat-checkbox>
      </div>
      <div class="px-3 activity-description-bold" [innerHTML]="eachTerms.labelText | safeHtml"></div>
    </div>
    <div class="py-2 d-flex flex-nowrap" *ngFor="let eachReminder of reminderSmsEmailChecks; let i = index">
      <div>
        <mat-checkbox class="chip-control__checkbox" [(ngModel)]="eachReminder.labelValue" #eachTerms="ngModel"
          [disabled]="eachReminder.disabled" [checked]="eachReminder.labelValue" name="{{ eachReminder.name }}"
          (ngModelChange)="checkCustomTermsAndMessageOptionValidation()"></mat-checkbox>
      </div>
      <div class="px-3 activity-description-bold" [innerHTML]="eachReminder.labelText | safeHtml"></div>
    </div>
    <span class="validation-error" *ngIf="formSubmitted && checkBoxErrorMessages && !activityService.DisableCustomTermsAndConditions">
      {{ checkBoxErrorMessages }}
    </span>
    <ng-container *ngIf="activityService.DisableCustomTermsAndConditions">
      <span *ngIf="validationMessageList?.length" class="validation-info" [innerHTML]="validationMessageList[0]"></span>
      <ul *ngIf="validationMessageList?.length > 1">
        <li *ngFor="let validationMessage of validationMessageList | slice : 1; let i = index" class="validation-info ms-3" [innerHTML]="validationMessage"></li>
      </ul>
    </ng-container>
  </div>
</ng-template>